export { PlusIconIcon } from './plus';
